import { useLocation, useNavigate } from "react-router-dom";
import logo from "../img/logo-clean.png";
import sta from "../img/static.jpg";
import tong from "../img/tong.png";
import exp from "../img/exp.png";
import sin from "../img/sin.png";
import sin2 from "../img/sin2.png";
import gate from "../img/gate.png";
import look from "../img/look.png";
import dro from "../img/dro.png";
import Contact from "./Contact/Contact";
import { useEffect, useRef } from "react";

export default function Home () {

    useEffect(() => {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in");
                } else {
                    entry.target.classList.remove("fade-in");
                }
            });
        }, {
            threshold: 0.1
        });

        const targetElements = document.querySelectorAll(".fad");
        targetElements.forEach((element) => {
            observer.observe(element);
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    let navigate = useNavigate();

    const proRef = useRef(null);
    const conRef = useRef(null);

    const scrollToPro = () => {
        if (proRef.current) {
            proRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const scrollToCon = () => {
        if (conRef.current) {
            conRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
    };

    let location = useLocation();

    useEffect(() => {
        const proHash = location.hash;
    
        if (proHash === '#p' && proRef.current) {
          proRef.current.scrollIntoView({ behavior: 'auto' });
        }
      }, [location.hash]);

      useEffect(() => {
        const conHash = location.hash;
    
        if (conHash === '#c' && conRef.current) {
          conRef.current.scrollIntoView({ behavior: 'auto' });
        }
      }, [location.hash]);

    return(

        <div className="__next">
            <div className="css-isg"></div>
            <div className="p-navbar">
                <div className="p-container p-container-default">
                    <div className="p-container-inner p-navbar-inner-container">
                        <div className="p-navbar-logo-container">
                            <div className="p-navbar-logo-icon css-1nb" onClick={()=>{window.location.reload(); window.scrollTo(0, 0)}}>
                                <span className="icon p-icon" aria-hidden='false' role="presentation">
                                    <img src={logo} alt="img"className="logo-icon"></img>
                                </span>
                            </div>
                        </div>
                        <div className="p-navbar-right-on-mobile">
                            <button className="p-navbar-dropdown-toggler reset-button" aria-label="메뉴열기">
                                <span className="icon p-icon icon--colored p-icon--colored" aria-hidden='false' role="presentation">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="line-icon">
                                        <path fill="#B0B8C1" d="M4.118 6.2h16a1.2 1.2 0 100-2.4h-16a1.2 1.2 0 100 2.4m16 4.6h-16a1.2 1.2 0 100 2.4h16a1.2 1.2 0 100-2.4m0 7h-16a1.2 1.2 0 100 2.4h16a1.2 1.2 0 100-2.4" fill-rule="evenodd"></path>
                                    </svg>
                                </span>
                            </button>
                        </div>
                        <div className="p-navbar-content" aria-expanded='false' aria-hidden='true'>
                            <ul className="p-navbar-menu"></ul>
                            <ul className="p-navbar-menu">
                                <li className="p-navbar-item">
                                    <div className="p-navbar-item tag" onClick={()=>{navigate('/about')}}>회사소개</div>
                                </li>
                                <li className="p-navbar-item">
                                    <div className="p-navbar-item tag" onClick={scrollToPro}>제품소개</div>
                                </li>
                                <li className="p-navbar-item">
                                    <div className="p-navbar-item tag" onClick={scrollToCon}>고객문의</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className>

                <div className="css-1i7 e7d">
                    <div className="css-bjn ead">
                        <div className="css-1dv">
                            <img src={sta} alt="img" className="css-1uv ead"></img>
                        </div>
                        <div className="css-1m3 ead"></div>
                        <div className="css-ji1 ead">
                            <div className="css-10z fade-in-text">
                                <h1 className="css-1v4">재난현장 등 열악한 환경에 <br></br>
                                                        적합한 고신뢰 통신모듈은 <br></br>
                                                        기보에서 찾으세요
                                </h1>
                                <div className="css-1ig">
                                    <button className="p-button css-kcm" onClick={scrollToCon}>Contact</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="css-1m6">
                        <p className="css-1dn">                            
                            첨단 고신뢰통신 기술, <br></br>
                            기보와 함께 하면 통신은 물론 거리측정도 가능합니다.
                        </p>
                    </div>
                </div>
                
                <div className="css-1i7 e7d fad" ref={proRef}>
                    <div className="p-container p-container-default css-1ot">
                        <div className="p-container__inner">
                            <div className="css-1w1" id="product">
                                <div className="css-udl">
                                    <div className="css-ymg e1p"></div>
                                    <h1 className="css-1kc">고신뢰통신기술</h1>
                                    <h2 className="css-csr">
                                        첨단 고신뢰통신기술, <br></br>
                                        열악한 재난환경에 적합한  <br></br>
                                        Filter-Bank 방식의 고신뢰통신기술
                                    </h2>
                                </div>
                                <div className="css-ymg">
                                    <div className="e1p css-lko ey5">
                                        <img src={tong} alt="img" className="css-181 ey5"></img>                                        
                                    </div>
                                </div>
                                <div className="e2p css-1vb ey5">
                                    <img src={exp} alt="img" className="css-i81 ey5"></img>
                                </div>
                                <p className="css-lk5 e1p">
                                채널간 Isolation<br></br>
                                High Dynamic Range<br></br>
                                다채널 고신뢰성 RF 통신<br></br>
                                920MHz, 2.4GHz 초소형 세라믹 안테나
                            </p>
                            </div>                            
                        </div>
                    </div>
                </div>

                <div className="css-vju fad">
                    <div className="p-container p-container-default css-8vb">
                        <div className="p-container__inner">
                            <div className="css-bjn e1g">
                                <div className="css-awf">
                                    <h1 className="css-1kc e1b">인명구조용 통신장비</h1>
                                    <h2 className="css-6u9 e1b">
                                        화재 등 재난 상황에서 <br></br>
                                        구조자의 안전관리를 위해
                                    </h2>
                                </div>
                                <div className="css-l0g e98">
                                    <div className="css-6h0 e1g">
                                        <p className="css-nni">
                                            <span className="icon p-icon css-qam" aria-hidden='false' role="presentation">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" ">
                                                    <path d="M11.6.7L2.9 4.2c-.4.2-.7.6-.7 1v8.3c0 3.8 4.8 7.5 9.3 9.8.3.1.6.1.9 0 4.5-2.3 9.3-6 9.3-9.8V5.2c0-.4-.2-.8-.6-.9L12.4.7c-.3-.1-.6-.1-.8 0z" fill="orange"></path><path d="M10.9 15.8c-.3 0-.5-.1-.7-.3l-3.4-3.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.7 2.7 4.9-4.9c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5.6 5.6c-.2.2-.4.3-.7.3z" fill="#fff"></path>
                                                </svg>
                                            </span>
                                            인명구조경보기
                                        </p>
                                        <p className="css-n06">
                                            열악한 통신 환경 상황에서도 <br></br>
                                            혼간섭이나 끊김없이 통신이 가능합니다.
                                        </p>
                                        <p className="css-vhi">
                                            모든 사용자간의 상대거리를 측정하며 통신을 연결합니다.
                                        </p>
                                    </div>
                                    <img src={sin} alt="img" className="css-buy e1g sp1"></img>
                                </div>
                                <div className="css-1je e98">
                                    <img src={sin2} alt="img" className="css-buy e1g"></img>
                                    <div className="css-6h0 e1g">
                                        <p className="css-nni">
                                            <span className="icon p-icon css-qam" aria-hidden='false' role="presentation">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" ">
                                                    <path d="M11.6.7L2.9 4.2c-.4.2-.7.6-.7 1v8.3c0 3.8 4.8 7.5 9.3 9.8.3.1.6.1.9 0 4.5-2.3 9.3-6 9.3-9.8V5.2c0-.4-.2-.8-.6-.9L12.4.7c-.3-.1-.6-.1-.8 0z" fill="orange"></path><path d="M10.9 15.8c-.3 0-.5-.1-.7-.3l-3.4-3.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.7 2.7 4.9-4.9c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5.6 5.6c-.2.2-.4.3-.7.3z" fill="#fff"></path>
                                                </svg>
                                            </span>
                                            위치추적기
                                        </p>
                                        <p className="css-n06">
                                            요구조자와의 거리와 방향을<br></br>
                                            측정하면서 위치를 추적합니다.
                                        </p>
                                        <p className="css-vhi">
                                            정밀 거리측정 및 방향탐지 기능은<br></br>
                                            재난 현장의 구조 대상자 위치를 신속하게 찾아낼 수 있게 합니다.
                                        </p>
                                    </div>
                                </div>
                                <div className="css-l0g e98">
                                    <div className="css-6h0 e1g">
                                        <p className="css-nni">
                                            <span className="icon p-icon css-qam" aria-hidden='false' role="presentation">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" ">
                                                    <path d="M11.6.7L2.9 4.2c-.4.2-.7.6-.7 1v8.3c0 3.8 4.8 7.5 9.3 9.8.3.1.6.1.9 0 4.5-2.3 9.3-6 9.3-9.8V5.2c0-.4-.2-.8-.6-.9L12.4.7c-.3-.1-.6-.1-.8 0z" fill="orange"></path><path d="M10.9 15.8c-.3 0-.5-.1-.7-.3l-3.4-3.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.7 2.7 4.9-4.9c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5.6 5.6c-.2.2-.4.3-.7.3z" fill="#fff"></path>
                                                </svg>
                                            </span>
                                            게이트웨이 & 에뮬레이터
                                        </p>
                                        <p className="css-n06">
                                            160대 이상의 다채널 신호를<br></br>
                                            동시 수신하고 상대거리를 측정합니다.
                                        </p>
                                        <p className="css-vhi">
                                            다채널 RF 고신뢰성 통신 모듈을 사용하여<br></br>
                                            모든 인명구조경보기와의 통신과 상대 거리를 측정합니다.
                                        </p>
                                    </div>
                                    <img src={gate} alt="img" className="css-buy2 e1g"></img>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="css-1i7 fad">
                    <div className="p-container p-container-default css-8vb">
                        <div className="p-container__inner">
                            <div className="css-bjn e14">
                            <div className="css-awf">
                                    <h1 className="css-1kc e1b">EO/IR 감시 장비</h1>
                                    <h2 className="css-6u9 e1b">
                                        놓쳐서 안되는 빈틈, <br></br>
                                        고성능 EO/IR 감시장비로 해결
                                    </h2>
                                </div>
                                <div className="css-l0g e98">
                                    <div className="css-6h0 e1g">
                                        <p className="css-nni">
                                            <span className="icon p-icon css-qam" aria-hidden='false' role="presentation">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" ">
                                                    <path d="M11.6.7L2.9 4.2c-.4.2-.7.6-.7 1v8.3c0 3.8 4.8 7.5 9.3 9.8.3.1.6.1.9 0 4.5-2.3 9.3-6 9.3-9.8V5.2c0-.4-.2-.8-.6-.9L12.4.7c-.3-.1-.6-.1-.8 0z" fill="orange"></path><path d="M10.9 15.8c-.3 0-.5-.1-.7-.3l-3.4-3.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.7 2.7 4.9-4.9c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5.6 5.6c-.2.2-.4.3-.7.3z" fill="#fff"></path>
                                                </svg>
                                            </span>
                                            고성능 EO/IR 감시장비
                                        </p>
                                        <p className="css-n06">
                                            주야간 국경지역 감시 및 대드론 감시에 적합합니다.
                                        </p>
                                        {/* <p className="css-vhi">
                                            대드론 감시 및 국경해안선 감시에 적합해요.
                                        </p> */}
                                    </div>
                                    <img src={look} alt="img" className="css-buy e1g"></img>
                                </div>
                                <div className="css-1je e98">
                                    <img src={dro} alt="img" className="css-buy e1g"></img>
                                    <div className="css-6h0 e1g">
                                        <p className="css-nni">
                                            <span className="icon p-icon css-qam" aria-hidden='false' role="presentation">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" ">
                                                    <path d="M11.6.7L2.9 4.2c-.4.2-.7.6-.7 1v8.3c0 3.8 4.8 7.5 9.3 9.8.3.1.6.1.9 0 4.5-2.3 9.3-6 9.3-9.8V5.2c0-.4-.2-.8-.6-.9L12.4.7c-.3-.1-.6-.1-.8 0z" fill="orange"></path><path d="M10.9 15.8c-.3 0-.5-.1-.7-.3l-3.4-3.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.7 2.7 4.9-4.9c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5.6 5.6c-.2.2-.4.3-.7.3z" fill="#fff"></path>
                                                </svg>
                                            </span>
                                            드론용 짐벌 카메라
                                        </p>
                                        <p className="css-n06">
                                            고성능 국산 EO/IR 짐벌카메라  <br></br>
                                        </p>
                                        <p className="css-vhi">
                                            필요에 따라 다양한 카메라 및 LRF 적용이 가능합니다.<br></br>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="css-5lk" ref={conRef}>
                    <div className="css-j6v">

                    </div>
                    <div className="css-awf fad" id="contact" >
                        <h1 className="css-jtl egd">열악한 환경에서의 통신사업은 기보와 함께</h1>
                        <p className="css-1wu egd">
                            재난현장, 군 및 경찰의 건물내 / 지하시설 작전현장 등 <br></br>
                            특수한 환경에서의 통신대책은 기보와 함께 협의하세요.
                        </p>
                        <Contact></Contact>
                    </div>
                </div>

            </div>
            <div className="p-footer p-footer-dark">
                <div className="p-footer-inner">
                    <div className="p-footer-address">
                        <strong className="p-footer-address-company">기보주식회사</strong>
                        <p className="p-footer-font">사업자 등록번호 : 740-87-02505 | 대표 : 문성철</p>
                        <p className="p-footer-font">본사 : 경기도 시흥시 은계중앙로 247, 103호</p>
                        <p className="p-footer-font">부설연구소 : 경기도 성남시 중원구 둔촌대로 388, 1506호</p>
                        <p className="p-footer-font">연락처 : TEL : 010-5072-9794</p>
                        <p className="p-footer-font">연락처 : FAX : 031-733-7569</p>
                        <a href='mailto:ceo@givo.co.kr'><p className="p-footer-emailfont">ceo@givo.co.kr</p></a>
                        <br></br><br></br><br></br><br></br>
                        <p className="p-footer-font">Copyright © GIVO. All Rights Reserved.</p>                        
                    </div>
                </div>
            </div>
        </div>

    )
}